import { View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import { PMSmallTable } from "@pimo/pimo-components/src/lib/pm-components";

import { TestAppState } from "../../../app";
import { theme } from "../../../theme";

export function addContractsCard(
  view: View<TestAppState, DragAndDropLayout>
): void {
  const contractsComponent = view.addComponent({
    component: PMSmallTable,
    layoutProps: {
      componentId: "contractsDashboardComponent",
      labels: ["contracts", "list"],
      description: "Shows a simple list of contracts.",
      title: "Contracts",
    },
  });

  contractsComponent.mapState(() => ({
    title: "Contracts",
    icon: "Description",
    items: [
      {
        label: "Name Test Contract 1",
        value: "PDF, contract-2025.pdf",
        chipColor: theme.palette.secondary.main,
        chipTextColor: theme.palette.primary.main,
      },
      {
        label: "Name Test Contract 2",
        value: "TXT, contract-XXX.txt",
        chipColor: theme.palette.secondary.main,
        chipTextColor: theme.palette.primary.main,
      },
    ],
    fixedHeight: "134px",
  }));
}
